export const LISA_CLASS_CODES = [
    11210, 11215, 11225, 11320, 11327, 11330, 11500, 11505, 11756, 11757, 11758, 11765,
    12210, 12215, 12225, 12320, 12327, 12330, 12500, 12505, 12756, 12757, 12758, 12765,
    29550, 29710, 29720, 29721, 29730, 30305, 30306, 30350, 30355, 30405, 30410, 30420,
    30550, 30551, 40210, 40215, 40225, 40320, 40327, 40330, 40500, 40505, 40756, 40757,
    40758, 40765, 91545, 91550, 91560, 95400, 95800, 300255, 300851, 300900
];

export const HECTOR_CLASS_CODES = [
    50077, 50078, 50079, 50401, 50402, 50403, 50404, 50449, 50450, 50701, 50702,
    60401, 60402, 60403, 60404, 60454, 60458, 60459, 60460, 60475
];

export const AARON_CLASS_CODES = [
    21205, 21210, 21215, 21220, 21293, 21295, 21300, 21311, 21312, 21327, 21351, 21352,
    21711, 21712, 21713, 21718, 21719, 21765, 22205, 22210, 22215, 22220, 22293, 22295,
    22300, 22311, 22312, 22327, 22351, 22352, 22711, 22712, 22713, 22718, 22719, 22765,
    34550, 34710, 34720, 34721, 34730, 34740, 35305, 35320, 35325, 35550, 35551, 35705,
    35706, 35710, 35715, 45205, 45210, 45215, 45220, 45293, 45295, 45300, 45311, 45312,
    45327, 45351, 45352, 45711, 45712, 45713, 45718, 45719, 45765, 70200, 70300, 70705,
    70710, 70715, 70720, 91585, 91600, 91605, 91610, 91615, 91630, 91631, 91802, 91803,
    91804, 91821, 91822, 91823, 91824, 91826, 91827, 91830, 91841, 91842, 91845, 91846,
    92401, 92800, 200255, 200300, 200900
];